// import Uiconstants from '../../lib/UIconstants';

export const DailyQuest = {
	name: 'quest_daily',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'itemheader',
			type: 'Text',
			position: { x: 316, y: 108 },
			text: 'QUEST_DAILY_TITLE'
		},
		{
			name: 'icon',
			type: 'Sprite',
			img: 'trophy_icon',
			position: { x: 316, y: 153 }
		},
		{
			name: 'itemsubtitle',
			type: 'Text',
			position: { x: 346, y: 150 },
			text: 'QUEST_DAILY_SUBTITLE'
		},
		{
			name: 'icon',
			type: 'Sprite',
			img: 'clock_icon',
			position: { x: 540, y: 153 }
		},
		{
			name: 'itemdesc',
			type: 'Text',
			position: { x: 568, y: 150 },
			text: 'QUEST_TIMER_ICON'
		}
	]
};
